import useSettings from "app/hooks/useSettings";

export default function MatxLogo({ className, height, width }) {
  const { settings } = useSettings();
  const theme = settings.themes[settings.activeTheme];

  return (
    // <svg
    //   width="24px"
    //   height="24px"
    //   className={className}
    //   viewBox="0 0 240 239"
    //   version="1.1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   xmlnsXlink="http://www.w3.org/1999/xlink">
    //   <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    //     <g
    //       id="logo"
    //       transform="translate(120.500000, 98.000000) rotate(-270.000000) translate(-120.500000, -98.000000) translate(-21.000000, -35.000000)">
    //       <g
    //         id="Group"
    //         transform="translate(141.500000, 133.000000) rotate(90.000000) translate(-141.500000, -133.000000) translate(9.000000, -8.000000)">
    //         <g
    //           id="Path-4-Copy"
    //           transform="translate(132.242532, 149.243361) rotate(-135.000000) translate(-132.242532, -149.243361) translate(38.742532, 55.743361)">
    //           <g id="path-1-link" fill="#000000">
    //             <polygon
    //               id="path-1"
    //               points="136.269985 0.8695976 186.615824 50.367072 186.615824 186.98041 50.7100649 186.98041 0.4346189 136.704964"></polygon>
    //           </g>
    //           <g id="path-1-link" fill={theme.palette.primary.light}>
    //             <polygon
    //               id="path-1"
    //               points="136.269985 0.8695976 186.615824 50.367072 186.615824 186.98041 50.7100649 186.98041 0.4346189 136.704964"></polygon>
    //           </g>
    //         </g>
    //         <polygon
    //           id="Path-3"
    //           fill={theme.palette.primary.light}
    //           points="13 238.415212 13 0 249.898437 238.415212"></polygon>
    //         <polygon
    //           id="Path-4"
    //           fill={theme.palette.primary.main}
    //           points="252.486992 0 252.486992 238.799226 13 238.799226"></polygon>
    //       </g>
    //     </g>
    //   </g>
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 74 51"
      fill="none"
    >
      <g clip-path="url(#clip0_7175_18156)">
        <path
          d="M73.4438 25.4473L58.8537 0.199219H51.5586L66.1474 25.4473L51.5586 50.6939H58.8537L73.4438 25.4473Z"
          fill="url(#paint0_linear_7175_18156)"
        />
        <path
          d="M51.5593 38.0709H29.6754L26.0272 31.7578L22.3789 38.0709L26.0272 44.384H47.911L51.5593 38.0709Z"
          fill="#E03E32"
        />
        <path
          d="M51.5591 25.4467L47.9108 31.7569H55.2058L58.8542 25.4467L47.9108 6.51172H40.6172L51.5591 25.4467Z"
          fill="#5DC972"
        />
        <path
          d="M40.6177 19.1328H33.3212L29.6758 25.4459L33.3212 31.7561H40.6177L44.2631 25.4459L40.6177 19.1328Z"
          fill="#3CB1E5"
        />
        <path
          d="M29.6776 12.8219H36.9713L33.323 6.51172H26.0293L15.0859 25.4467L18.7342 31.7569L29.6776 12.8219Z"
          fill="#F2C762"
        />
        <path
          d="M7.7926 25.4473L11.438 19.1342L15.0863 12.8226L18.7345 6.51233L22.3814 0.199219H15.0863L11.438 6.51233L0.496094 25.4473L15.0863 50.6939H22.3814L7.7926 25.4473Z"
          fill="url(#paint1_linear_7175_18156)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7175_18156"
          x1="62.5021"
          y1="0.199219"
          x2="62.5021"
          y2="50.6939"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stop-color="#3CB1E5" />
          <stop offset="1" stop-color="#4AA85E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7175_18156"
          x1="11.4395"
          y1="0.199219"
          x2="11.4395"
          y2="50.6939"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stop-color="#F2C762" />
          <stop offset="1" stop-color="#F9413D" />
        </linearGradient>
        <clipPath id="clip0_7175_18156">
          <rect width="73" height="50.5183" fill="white" transform="translate(0.476562 0.199219)" />
        </clipPath>
      </defs>
    </svg>
  );
}
